import React, { Component } from "react"
import { Input, Table, message, Select } from "antd"
import request from "app/vendor/request"
import config from "app/config"
import editAbleIcon from "app/styles/images/sp/edit.svg"
import MaterialModal from "app/components/normal/MaterialModal"
import { observer, inject } from "mobx-react"
import closeIcon from "app/styles/images/sp/close.svg"
import MaterialForm from "app/components/normal/MaterialForm/MaterialForm"
import SwitchS from "app/components/normal/FormComponents"
import MaterialFormItem from "app/components/normal/MaterialFormItem/MaterialFormItem"

const Option = Select.Option
const ObserverSwitch = observer(({ record, toggleSwitch }) => {
  return (
    <SwitchS
      onChange={() => toggleSwitch(record)}
      checked={!record.disable}
    />
  )
})

@inject("auth") @observer
class Index extends Component {
  constructor(props) {
    super(props)
    this.state = {
      showEditModal: false,
      dataSingle: {},
    }
  }

  componentDidMount() {
    const { store: { list } } = this.props
    list.getTableData()
      .then(
        res => {
          list.updateTableData(res)
          list.initPageIndex()
        }
      )
  }

  onPaginChange = selectedPageNumber => {
    let {
      store: {
        list
      },
    } = this.props

    list.changePagin(selectedPageNumber)

    document.getElementById("contentTop").scrollIntoView(true)
  }

  showEditModal = (record) => {
    this.setState({
      showEditModal: true,
    })
  }

  closeModal = (modal) => {
    this.setState({
      [modal]: false
    })
  }

  handleEdit = (record) => {
    this.setState({
      dataSingle: record,
      showEditModal: true,
    })
  }

  changeDetailData = (e, filed) => {
    this.setState({
      dataSingle: {
        ...this.state.dataSingle, [filed]: filed === 'defaultBaseline' ?
          (Number(e) === 1 ? true : false) : e
      }
    })
  }

  updateOrg = () => {
    const { dataSingle } = this.state
    const { list } = this.props.store
    return request.put(`${config.backend}/pgs/baselines/${dataSingle.id}`)
      .send({
        defaultBaseline: dataSingle.defaultBaseline,
        baselineParam: dataSingle.baselineParam
      })
      .checkToken()
      .commonDispose()
      .then(
        res => {
          list.getTableData()
            .then(
              res => {
                list.updateTableData(res)
                list.initPageIndex()
              }
            )
          return Promise.resolve(res)
        },
        err => {
          message.error(err)
          return Promise.reject(err)
        }
      )
  }

  render() {
    const { dataSingle } = this.state

    const {
      store: {
        list: {
          tableData,
          totalCount,
          queryMap,
          currentPageIndex,
        }
      },
    } = this.props

    const columns = [
      {
        width: "10%",
        title: (<div className="ta-c">应用名称</div>),
        className: "ta-c",
        dataIndex: "appName",
        render: (text) => {
          return (
            <div>{text}</div>
          )
        }
      }, {
        width: "7%",
        title: (<div className="ta-c">应用Id</div>),
        dataIndex: "appId",
        className: "ta-c",
        render: (text) => {
          return (
            <div>{text}</div>
          )
        }
      }, {
        width: "10%",
        title: (<div className="ta-c">基线版本</div>),
        className: "ta-c",
        dataIndex: "baselineName",
        render: (text) => {
          return (
            <div>{text || '-'}</div>
          )
        }
      }, {
        width: "10%",
        title: (<div className="ta-c">基线参数</div>),
        className: "ta-c",
        dataIndex: "baselineParam",
        render: (text, record, index) => {
          return (
            <div>{text || "-"}</div>
          )
        }
      }, {
        width: "8%",
        title: (<div className="ta-c">机构Id</div>),
        className: "ta-c",
        dataIndex: "orgId",
        render: (text) => {
          return (
            <div>{text || "-"}</div>
          )
        }
      },
      {
        width: "12%",
        title: (<div className="ta-c">机构名称</div>),
        className: "ta-c",
        dataIndex: "orgName",
        render: (text) => {
          return (
            <div>{text || "-"}</div>
          )
        }
      },
      {
        width: "10%",
        title: (<div className="ta-c">用户Id</div>),
        className: "ta-c",
        dataIndex: "userId",
        render: (text) => {
          return (
            <div>{text || "-"}</div>
          )
        }
      },
      {
        width: "10%",
        title: (<div className="ta-c">用户名</div>),
        className: "ta-c",
        dataIndex: "username",
        render: (text) => {
          return (
            <div>{text || "-"}</div>
          )
        }
      }, {
        width: "10%",
        title: (<div className="ta-c">默认基线</div>),
        className: "ta-c",
        dataIndex: "defaultBaseline",
        render: (text) => {
          return (
            <div>{text ? "是" : "否"}</div>
          )
        }
      }, {
        width: "10%",
        title: (<div className="ta-c">创建时间</div>),
        className: "ta-c",
        dataIndex: "createTime",
        render: (text) => {
          return (
            <div>{text || "-"}</div>
          )
        }
      }, {
        width: "8%",
        title: (<div className="ta-c">是否启用</div>),
        className: "ta-c",
        dataIndex: "disable",
        render: (text, record) => {
          const { toggleSwitch } = this.props.store
          return (
            <ObserverSwitch
              toggleSwitch={toggleSwitch}
              record={record}
            />
          )
        }
      }, {
        width: 100,
        title: (<div className="ta-c">操作</div>),
        dataIndex: "operator",
        className: "ta-c",
        render: (text, record) => {
          return (
            <div>
              <img
                title="修改"
                src={editAbleIcon}
                alt=""
                style={{ cursor: 'pointer' }}
                onClick={() => this.handleEdit(record)}
              />
            </div>
          )
        }
      }
    ]

    return (
      <div className="wrapper-box">
        <Table
          columns={columns}
          className="statistics-table"
          rowKey={record => record.id}
          dataSource={tableData.slice()}
          pagination={{
            pageSize: queryMap.limit,
            onChange: this.onPaginChange,
            defaultCurrent: 1,
            current: currentPageIndex,
            total: totalCount,
          }}
        />
        <MaterialModal
          title="编辑基线"
          width={450}
          className="preview-account-create-modal"
          visible={this.state.showEditModal}
          buttonText="确认提交"
          action={
            () => {
              this.updateOrg()
                .then(
                  res => {
                    message.success('修改成功')
                    this.closeModal('showEditModal')
                  }
                )
            }

          }
        >
          <img
            className="pgx-modal-close"
            src={closeIcon}
            alt="关闭对话框"
            onClick={() => this.closeModal("showEditModal")}
          />
          <MaterialForm>
            <MaterialFormItem
              labelText="基线参数"
              labelWidth={60}
            >
              <Input
                className="createAccount-input"
                placeholder="请输入基线参数"
                value={dataSingle.baselineParam}
                onChange={(e) => this.changeDetailData(e.target.value, 'baselineParam')}
              />
            </MaterialFormItem>
            <MaterialFormItem
              labelWidth={60}
              labelText="是否默认"
              justify="center"
            >
              <Select
                className="createAccount-input"
                onChange={(e) => this.changeDetailData(e, 'defaultBaseline')}
                defaultValue=""
                value={dataSingle.defaultBaseline ? '1' : '0'}
              >
                <Option value="" disabled>请选择</Option>
                <Option value="1">是</Option>
                <Option value="0">否</Option>
              </Select>
            </MaterialFormItem>
          </MaterialForm>
        </MaterialModal >
      </div >
    )
  }
}

export default Index



// WEBPACK FOOTER //
// ./src/app/pages/preview/baseline/containers/DataTable.js